import { Length, Percentage } from '@wix/editor-elements-panel-service';
import { CombinedControlTypes, ShadowStyleValue } from '../../types';

interface ControlConverter<TInput, TOutput> {
  importValue(combinedValue: ShadowStyleValue): TOutput;
  exportValue(value: TInput): Partial<ShadowStyleValue>;
}

class OpacityControlConverter
  implements ControlConverter<Percentage, Percentage>
{
  importValue(combinedValue: ShadowStyleValue): Percentage {
    // @ts-expect-error - TODO: fix this
    const value = combinedValue?.color?.alpha?.value;
    return {
      type: 'Percentage',
      value: value ? value * 100 : 0,
    };
  }

  exportValue(value: Percentage): Partial<ShadowStyleValue> {
    // @ts-expect-error - TODO: ds-types-bump
    return {
      color: {
        alpha: {
          type: 'Percentage',
          value: value.value / 100,
        },
      },
    };
  }
}

class BlurControlConverter implements ControlConverter<Length, Length> {
  importValue(combinedValue: ShadowStyleValue): Length {
    return {
      // @ts-expect-error - TODO: ds-types-bump
      type: 'Length',
      // @ts-expect-error - TODO: ds-types-bump
      value: combinedValue?.blurRadius?.value ?? 0,
      unit: 'px',
    };
  }

  // @ts-expect-error - TODO: ds-types-bump
  exportValue(value: Length) {
    return {
      blurRadius: value,
    };
  }
}

type ConverterMap = {
  ShadowOpacity: OpacityControlConverter;
  ShadowBlur: BlurControlConverter;
};

type ControlValueMap = {
  ShadowOpacity: Percentage;
  ShadowBlur: Length;
};

export class CombinedControlConverter<
  T extends CombinedControlTypes = CombinedControlTypes,
> {
  private controlType: T;
  private converter: ConverterMap[T];

  constructor(controlType: T) {
    this.controlType = controlType;
    this.converter = this.getConverter(controlType);
  }

  private getConverter(controlType: T): ConverterMap[T] {
    switch (controlType) {
      case 'ShadowOpacity':
        return new OpacityControlConverter() as ConverterMap[T];
      case 'ShadowBlur':
        return new BlurControlConverter() as ConverterMap[T];
      default:
        throw new Error(`Unknown control type: ${controlType}`);
    }
  }

  importValue(combinedValue: ShadowStyleValue): ControlValueMap[T] {
    return this.converter.importValue(combinedValue) as ControlValueMap[T];
  }

  exportValue(value: ControlValueMap[T]): Partial<ShadowStyleValue> {
    // @ts-expect-error - TODO: ds-types-bump
    return this.converter.exportValue(value as any);
  }
}
